import type { JsonValue } from 'type-fest';

import { prepareAndMakeRequest } from '@frontend/api';

import { keysToSnakeCase } from 'utils/stringUtils';

export default {
  viewAndRateVideo: (
    videoId: string,
    data: { secondsLapsed: number; rating?: number },
  ): Promise<JsonValue> =>
    prepareAndMakeRequest.post<JsonValue>(
      `/help_mode/videos/${videoId}/views`,
      { body: keysToSnakeCase(data) },
    ),
  getReleaseVideos: (): Promise<JsonValue> =>
    prepareAndMakeRequest.get<JsonValue>(`/help_mode/releases`),
  getPageLevelVideos: (videoGroup: string): Promise<JsonValue> =>
    prepareAndMakeRequest.get<JsonValue>(
      `/help_mode/video_group/${videoGroup}/page_level/`,
    ),
  getAdditionalResourceVideos: (videoGroup: string): Promise<JsonValue> =>
    prepareAndMakeRequest.get<JsonValue>(
      `/help_mode/video_group/${videoGroup}/resources/`,
    ),
};
